import printTestReportReducer from "./printTestReportReducer";

const testReportReducers = {
    printTestReport: printTestReportReducer
};

export default testReportReducers;